import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-payment-item-detail',
    templateUrl: './payment-item-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentItemDetailComponent {
    @ViewChild(TemplateRef)
    content: TemplateRef<HTMLElement>;
}
